import React, {useEffect, useContext, useState, useRef} from 'react';
import ChantierInfoNoteView from './ChantierInfoNoteView';
import '../ChantierInfoPhoto/ChantierInfoPhoto.css';
import {useNavigate} from 'react-router';
import {useParams} from 'react-router-dom';
import {getNotes, getUsers} from '../../../services/MadricService';
import {MadricContext} from '../../../Context/MadricContext';
import moment from 'moment/moment';
import Spinner from '../../Spinner/Spinner';


/**
 *  L'accueil
 * @return {JSX}
 */
function ChantierInfoNote() {
  const navigate = useNavigate();
  const {id} = useParams();


  const {projectInfoObtained, projectInfo, setProjectInfo, listeEmploye, setListeEmploye} = useContext(MadricContext);

  const [filteredArray, setFilteredArray] = useState([]);
  const [isLoading, setIsLoading] = useState(false);


  const filterForm = useRef({inputRef: {label: 'Filtrer par nom'},
    dateRef: '',
    extra1: false,
    extra2: false,
    extra3: false});


  useEffect(() => {
    if (!projectInfoObtained.current.includes('note')) {
      projectInfoObtained.current = [...projectInfoObtained.current, 'note'];
      fetchNotes();
    } else {
      setFilteredArray(projectInfo.filter((item) => item.type === 'note'));
    }

    if (listeEmploye.length === 0) {
      fetchEmploye();
    }
  }, []);

  /**
 * Va chercher la liste des employes
 */
  async function fetchEmploye() {
    const name = await getUsers();

    setListeEmploye(name);
  }

  /**
   * Va chercher la liste de notes
   */
  async function fetchNotes() {
    setIsLoading(true);
    const notes = await getNotes(id);

    setProjectInfo((prev) => [...prev, ...notes]);
    setFilteredArray(notes);
    setIsLoading(false);
  }


  const formatDate = (dateString) => {
    const date = moment.tz(dateString, 'America/Montreal');
    const dayNames = {
      Monday: 'Lundi',
      Tuesday: 'Mardi',
      Wednesday: 'Mercredi',
      Thursday: 'Jeudi',
      Friday: 'Vendredi',
      Saturday: 'Samedi',
      Sunday: 'Dimanche',
    };
    moment.locale('fr'); // set locale to French
    const dayName = dayNames[date.format('dddd')];
    return `${dayName} le ${date.format('DD-MM-YYYY')}`;
  };

  /**
   * Permet de naviguer vers la page pour ajouter une note
   */
  function addNote() {
    navigate('/AddNote', {state: {id}});
  }

  /**
   * Supprime le filtre de la date
   */
  function removeDate() {
    filterForm.current = {
      ...filterForm.current,
      dateRef: '',
      inputRef: {label: 'Filtrer par nom'},
    };
    filterData();
  }

  /**
     * Permet de filtrer par le nom
     * @param {*} event event
     */
  function handleChange(event) {
    filterForm.current = {
      ...filterForm.current,
      inputRef: event,
    };
    filterData();
  }

  /**
         * filtre du extra 1
         * @param {*} event event
         */
  function handleCheckboxChange(event) {
    filterForm.current = {
      ...filterForm.current,
      [event.target.name]: event.target.checked,
    };
    filterData();
  }

  /**
         * filtre de la date
         * @param {*} event event
         */
  function handleDateChange(event) {
    filterForm.current = {
      ...filterForm.current,
      dateRef: event,
    };
    filterData();
  }


  const filterExtra = (item1, item2, item3) => {
    const {extra1, extra2, extra3} = filterForm.current;

    const areAllExtrasFalse = !extra1 && !extra2 && !extra3;
    const isItem1Matching = item1 === extra1 && item1;
    const isItem2Matching = item2 === extra2 && item2;
    const isItem3Matching = item3 === extra3 && item3;

    return areAllExtrasFalse || isItem1Matching || isItem2Matching || isItem3Matching;
  };

  const filterData = () => {
    const dateRef = filterForm.current.dateRef;
    const filteredArrays = projectInfo.filter((item) => item.type === 'note').filter((item) => {
      const date1 = moment.tz(item.date, 'America/Montreal');
      const date2 = moment.tz(dateRef, 'America/Montreal');

      return ((item.user_name.toLowerCase() === filterForm.current.inputRef.label.toLowerCase() || filterForm.current.inputRef.label === 'Filtrer par nom') &&
          (date1.isSame(date2) || dateRef === '') &&
          filterExtra(item.extra1, item.extra2, item.extra3));
    });

    setFilteredArray(filteredArrays);
  };

  return (
    <React.Fragment>
      {isLoading && <Spinner />}

      <ChantierInfoNoteView
        addNote={addNote}
        filteredArray={filteredArray}
        handleCheckboxChange={handleCheckboxChange}
        removeDate={removeDate}
        handleDateChange={handleDateChange}
        handleChange={handleChange}
        filterForm={filterForm}
        dateRef={filterForm.current.dateRef}
        inputRef={filterForm.current.inputRef}
        formatDate={formatDate}
      />
    </React.Fragment>
  );
}

export default ChantierInfoNote;
